import { takeLatest, put } from 'redux-saga/effects';
import moment from 'moment';
import {
  patrimonioAlertaManutencaoCadastro,
  NEW_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO,
  NEW_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO_SUCCESS,
} from '@handler';

function* sagaNewPatrimonioAlertaManutencaoCadastro(action) {

  yield put({
    type: NEW_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO_SUCCESS,
    registro: {
      ...patrimonioAlertaManutencaoCadastro.newRegistro,
    },
    isCadastroRapido: action.isCadastroRapido,
    // status: true,
  });
}

export default function* watchNewPatrimonioAlertaManutencaoCadastro() {
  yield takeLatest(NEW_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO, sagaNewPatrimonioAlertaManutencaoCadastro)
}
